const convertMoneyToInteger = (str) => {
  return parseInt(str.match(/[0-9]/g).join(''), 10);
};

export default convertMoneyToInteger;
